import React, { useState, useEffect } from 'react';
import {
  Form, FormGroup, Label, Input, Row, Col, Button,
} from 'reactstrap';
import LaddaButton, { EXPAND_RIGHT } from 'react-ladda';
import PropTypes from 'prop-types';

import {
  getAccountType, InvestExperienceE, InvestExperienceQ, InvestExperienceM,
} from '../types';
import { CircularProgress } from '../../../..';

const InvestmentProfile = ({
  investment: investmentProfile,
  accountId,
  setAccountData,
  services,
}) => {
  const [loadingSave, setLoadingSave] = useState(false);
  const [changedInvestExperience, setChangedInvestExperience] = useState([]);

  useEffect(() => {
    if (!investmentProfile) {
      const body = {
        AccountGetInfo: {
          GetAccountDataId: accountId,
          GetAccountDataType: getAccountType.InvestmentProfile,
        },
      };
      services.fetchAccountSectorInfo(body, (data) => {
        if (data && data.SDTAccount) {
          setAccountData({
            AccountId: accountId,
            InvestExperience: data.SDTAccount.InvestExperience,
          }, false);
        }
      });
    }
  }, [setAccountData, accountId, investmentProfile, services]);

  const handleSave = () => {
    const newInvestExperience = [];
    changedInvestExperience.forEach((inv) => {
      if (inv) newInvestExperience.push(inv);
    });
    const body = {
      account: {
        AccountId: accountId,
        InvestExperience: newInvestExperience,
      },
      accountChangeType: getAccountType.InvestmentProfile,
    };
    setLoadingSave(true);
    services.fetchAccountUpdate(body, ({ result }) => {
      if (result && result.Code === 200) {
        const investExperience = [...investmentProfile];
        let index = -1;
        newInvestExperience.forEach((item) => {
          investExperience.forEach((e, i) => {
            if (parseInt(e.InvestExperienceId, 10) === parseInt(item.InvestExperienceId, 10)) {
              index = i;
            }
          });
          if (index > -1) {
            investExperience[index] = item;
            index = -1;
          }
        });
        setAccountData({
          AccountId: accountId,
          InvestExperience: investExperience,
        }, true);
        setChangedInvestExperience([]);
        setLoadingSave(false);
      } else {
        setLoadingSave(false);
      }
    });
  };

  const revert = () => setChangedInvestExperience([]);

  const onChange = (index, id, name, value) => {
    if (!loadingSave) {
      const newChange = [...changedInvestExperience];
      if (investmentProfile[index][name] !== value) {
        newChange[id] = {
          ...investmentProfile[index],
          ...newChange[id],
          [name]: value,
        };
      } else if (newChange[id]) {
        newChange[id][name] = value;
      }
      setChangedInvestExperience(newChange);
    }
  };

  if (!investmentProfile) {
    return (
      <CircularProgress sm />
    );
  }

  return (
    <div>
      <Form>
        <FormGroup tag="fieldset">
          {investmentProfile.map((inv, i) => (
            <Label key={inv.InvestExperienceId} style={{ display: 'block' }}>
              <Row>
                <Col colSpan={3} style={{ fontWeight: 500, fontSize: '15px' }}>
                  {inv.InvestExperienceDescription}
                  :
                </Col>
                <Col colSpan={3}>
                  <Label for="exampleSelect">Experience</Label>
                  <Input type="select" name="InvestExperienceE" id="exampleSelect" value={changedInvestExperience[inv.InvestExperienceId] ? changedInvestExperience[inv.InvestExperienceId].InvestExperienceE : inv.InvestExperienceE} onChange={(e) => onChange(i, inv.InvestExperienceId, e.target.name, e.target.value)}>
                    {InvestExperienceE.map((v) => (
                      <option key={v} value={v}>{v}</option>
                    ))}
                  </Input>
                </Col>
                <Col colSpan={3}>
                  <Label for="exampleSelect">Quantity</Label>
                  <Input type="select" name="InvestExperienceQ" id="exampleSelect" value={changedInvestExperience[inv.InvestExperienceId] ? changedInvestExperience[inv.InvestExperienceId].InvestExperienceQ : inv.InvestExperienceQ} onChange={(e) => onChange(i, inv.InvestExperienceId, e.target.name, e.target.value)}>
                    {InvestExperienceQ.map((v) => (
                      <option key={v} value={v}>{v}</option>
                    ))}
                  </Input>
                </Col>
                <Col colSpan={3}>
                  <Label for="exampleSelect">Amount</Label>
                  <Input type="select" name="InvestExperienceM" id="exampleSelect" value={changedInvestExperience[inv.InvestExperienceId] ? changedInvestExperience[inv.InvestExperienceId].InvestExperienceM : inv.InvestExperienceM} onChange={(e) => onChange(i, inv.InvestExperienceId, e.target.name, e.target.value)}>
                    {InvestExperienceM.map((v) => (
                      <option key={v} value={v}>{v}</option>
                    ))}
                  </Input>
                </Col>
              </Row>
            </Label>
          ))}
        </FormGroup>
      </Form>
      <Button
        style={{ marginRight: 10 }}
        disabled={loadingSave}
        onClick={() => revert()}
      >
        <i className="fa fa-undo" />
        {' '}
        Revert
      </Button>
      <LaddaButton
        className="btn btn-ladda btn-primary"
        loading={loadingSave}

        disabled={changedInvestExperience.length === 0}
        onClick={() => handleSave()}
        data-style={EXPAND_RIGHT}
      >
        Save
      </LaddaButton>
    </div>
  );
};

InvestmentProfile.propTypes = {
  accountId: PropTypes.string.isRequired,
  investment: PropTypes.array,
  setAccountData: PropTypes.func.isRequired,
  services: PropTypes.object.isRequired,
};

InvestmentProfile.defaultProps = {
  investment: undefined,
};

export default InvestmentProfile;
